import Device from 'constants/deviceSizes';

export default {
  innerContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '15px 20px',
    [Device.tablet]: {
      padding: '15px 0px 15px 15px'
    },
    [Device.mobile]: {
      padding: 0
    }
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    paddingBottom: 15,
    [Device.mobile]: {
      width: '55%',
      textAlign: 'left'
    }
  },
  bannerButton: {
    height: 'auto',
    padding: '6px 15px',
    width: '20%',
    [Device.mobile]: {
      width: '20%',
      minWidth: 90,
      padding: '6px 5px'
    }
  }
};
